import React, {useMemo} from 'react';

import {useUnit} from 'effector-react';

import {useTranslation} from 'react-i18next';

import {$subscriptionStatus} from '@/entities/subscriptions/model';
import {SubscriptionStatusEnum} from '@/entities/subscriptions/types';

import {userModel} from '@/entities/user/model';

import {TAXPAYER_ROLES} from '@/entities/user/permissions';

import {BannerButtons} from './BannerButtons';
import * as S from './styled';

const bannerText = {
    [SubscriptionStatusEnum.INACTIVE]: {
        title: 'inactiveTitle',
        description: 'inactiveDescription',
    },
    [SubscriptionStatusEnum.PAYMENT_PENDING]: {
        title: 'paymentPendingTitle',
        description: 'paymentPendingDescription',
    },
    [SubscriptionStatusEnum.CANCELLED]: {
        title: 'cancelledTitle',
        description: 'cancelledDescription',
    },
};

export const SubscriptionBanner = () => {
    const {t} = useTranslation();
    const user = useUnit(userModel);
    const subscriptionStatus = useUnit($subscriptionStatus);

    const bannerSetting = useMemo(() => {
        if (!user.state.role || !TAXPAYER_ROLES.includes(user.state.role)) return null;
        if (!subscriptionStatus) return null;
        if (subscriptionStatus.status === SubscriptionStatusEnum.ACTIVE) return null;
        return bannerText[subscriptionStatus.status] ?? null;
    }, [subscriptionStatus]);
    return (
        <>
            {bannerSetting ? (
                <S.Wrapper>
                    <S.Container>
                        <S.Pill $status={subscriptionStatus?.status}>
                            {t(`subscriptions.bannerStatus.${subscriptionStatus?.status}`)}
                        </S.Pill>
                        <S.BannerText>
                            <S.BannerTitle>
                                {t(`subscriptions.banner.${bannerSetting.title}`)}
                            </S.BannerTitle>
                            <S.BannerDescription>
                                {t(`subscriptions.banner.${bannerSetting.description}`)}
                            </S.BannerDescription>
                        </S.BannerText>
                        <S.BannerCTA>
                            <BannerButtons status={subscriptionStatus?.status} />
                        </S.BannerCTA>
                    </S.Container>
                </S.Wrapper>
            ) : (
                <S.Wrapper noBg>
                    <S.Container>
                        <S.Name>TraceCORE B2B E-Invoicing</S.Name>
                    </S.Container>
                </S.Wrapper>
            )}
        </>
    );
};
